import request from '@/utils/request'

export function getPermissionCode() {
  return request({
    url: '/api/member/permission-code',
    method: 'get'
  })
}
